export default {
    name: 'AlertMessage',
    data() {
        return {
            message: 'tetst message'
        }
    },
    props: {
        messageText: {
            type: String,
            default: ''
        },
        messageType: {
            type: String,
            validator: function (value) {
                // The value must match one of these lines
                return ['info', 'success', 'danger','warning'].indexOf(value) !== -1
            },
            default: 'info'
        },
        maxWidth: {
            type: Number,
            default: 680
        }
    }
}
